const supplyItemPaths = {
  SUPPLY_ITEM: "",
  SEARCH_SUPPLY_ITEM: "search",
  SUPPLY_ITEM_ID: (id) => id,
};

export default supplyItemPaths;
